import {types} from './types';

const initialState = {
    list: {
        data: [],
        countPage: 1,
    }
}

export function cashbackReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_GET_CASHBACK_LIST:
            return { ...state, list: action.payload};
        default:
            return state
    }
}